import { Component, EventEmitter, inject, Input, OnInit, Output, signal } from '@angular/core';
import { S3BucketEnum } from '../../common/general-types/media-assets.dto';
import { S3uploaderService } from '../../services/s3uploader/s3uploader.service';
import { BriefApplicationResponseDto } from '../../common/general-types/briefs.dto';

@Component({
  selector: 'atom-add-video',
  standalone: true,
  imports: [],
  templateUrl: './add-video.component.html',
  styleUrl: './add-video.component.css'
})
export class AddVideoComponent implements OnInit {

  @Input() focussedApplication: BriefApplicationResponseDto | undefined = undefined;

  @Input() initialVideo: string | undefined = undefined;
  @Input() clearOnUpload: boolean = false;
  @Input() size: 'sm' | 'md' | 'lg' = 'lg';

  @Output() videoUploaded = new EventEmitter<{ file: string, fileKey: string, fullUrl: string, videoId: string | undefined }>();

  public uploadService = inject(S3uploaderService);

  selectedFiles: any[] = [];
  completeVideo = signal<string>('');
  videoLoading = signal<boolean>(false);
  isDragging = signal<boolean>(false);
  uploadStatus = signal<string>('');

  ngOnInit(): void {
    if (this.initialVideo) {
      this.completeVideo.set(this.initialVideo);
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging.set(true);
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging.set(false);
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.isDragging.set(false);

    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const videoFiles: File[] = [];
      for (let i = 0; i < files.length; i++) {
        const file = files.item(i);
        if (file && file.type.startsWith('video/')) {
          videoFiles.push(file);
        }
      }

      if (videoFiles.length > 0) {
        const fileListLike = {
          length: videoFiles.length,
          item: (index: number) => videoFiles[index] || null,
          [Symbol.iterator]: function* () {
            for (let i = 0; i < videoFiles.length; i++) {
              yield videoFiles[i];
            }
          }
        } as FileList;

        const mockEvent = {
          target: {
            files: fileListLike
          }
        };
        this.selectFile(mockEvent);
      }
    }
  }

  selectFile(event: any): void {
    console.log('AVC - selectFile: ', event);
    this.selectedFiles = event.target.files;
    this.upload(this.selectedFiles);
  }

  async upload(selectedFiles: any) {
    console.log('AVC - upload: ', selectedFiles);
    this.videoLoading.set(true);
    this.uploadStatus.set('Uploading video…');
    this.uploadService.uploadPercentage.set(0);

    const uploadedFile = await this.uploadService.uploadVideo(selectedFiles, this.focussedApplication);
    console.log('AVC - uploadedFile: ', uploadedFile);

    if (uploadedFile) {
      if (!this.clearOnUpload) {
        this.completeVideo.set(uploadedFile.fullUrl);
      }
      this.videoLoading.set(false);
      this.uploadStatus.set('Upload complete');
      this.videoUploaded.emit({ file: uploadedFile.file, fileKey: uploadedFile.fileKey, fullUrl: uploadedFile.fullUrl, videoId: uploadedFile.videoId });
    } else {
      console.warn('Upload failed or canceled.');
      this.videoLoading.set(false);
      this.uploadStatus.set('Upload failed. Please try again.');
    }
  }
}
